import { motion } from "framer-motion";
import { toast } from "sonner";

const Apple = () => (
  <svg viewBox="0 0 24 24" className="h-5 w-5" fill="currentColor" aria-hidden="true">
    <path d="M16.37 12.6c-.02-2.2 1.8-3.26 1.88-3.31-1.03-1.5-2.62-1.7-3.18-1.73-1.35-.14-2.64.8-3.33.8-.69 0-1.74-.78-2.86-.76-1.47.02-2.83.86-3.59 2.17-1.53 2.65-.39 6.58 1.1 8.73.73 1.05 1.6 2.23 2.73 2.19 1.1-.05 1.51-.71 2.84-.71 1.32 0 1.7.71 2.86.69 1.18-.02 1.93-1.07 2.65-2.13.84-1.22 1.18-2.4 1.2-2.46-.03-.01-2.28-.88-2.3-3.48zM14.2 6.13c.6-.73 1-1.74.9-2.75-.86.04-1.9.57-2.52 1.3-.55.64-1.04 1.67-.91 2.66.96.07 1.94-.49 2.53-1.21z" />
  </svg>
);

const Play = () => (
  <svg viewBox="0 0 24 24" className="h-5 w-5" aria-hidden="true">
    <path d="M4 3.5v17a1 1 0 0 0 1.5.86L20 13a1.15 1.15 0 0 0 0-2L5.5 2.64A1 1 0 0 0 4 3.5z" fill="currentColor" />
  </svg>
);

const StoreBtn = ({ icon, small, big, testId, dark }) => (
  <motion.button
    type="button"
    data-testid={testId}
    whileHover={{ y: -3 }}
    whileTap={{ scale: 0.97 }}
    onClick={() => toast("Lunelle is almost here", { description: "Join the waitlist and we'll send your download link on launch day." })}
    className={`flex items-center gap-3 rounded-full px-5 py-3 text-left transition-colors duration-300 ${
      dark ? "bg-[#FBF5EE] text-[#2C221E] hover:bg-white" : "bg-[#2C221E] text-[#FBF5EE] hover:bg-[#453630]"
    }`}
  >
    {icon}
    <span className="leading-tight">
      <span className="block text-[10px] uppercase tracking-[0.18em] opacity-75">{small}</span>
      <span className="block text-sm font-semibold">{big}</span>
    </span>
  </motion.button>
);

export const StoreButtons = ({ prefix = "hero", dark = false }) => (
  <div className="flex flex-wrap gap-3">
    <StoreBtn icon={<Apple />} small="Download on the" big="App Store" testId={`${prefix}-download-appstore-button`} dark={dark} />
    <StoreBtn icon={<Play />} small="Get it on" big="Google Play" testId={`${prefix}-download-playstore-button`} dark={dark} />
  </div>
);
